import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxPrintModule } from 'ngx-print';
import { AuthGuard } from '../../shared/security/auth.guard';
import { SeverEmploymentNotificationComponent } from './sever-employment-notification/sever-employment-notification.component';
import { PTLSharedModule } from '../../shared/shared.module';
import { StartSeverEmploymentComponent } from './start-server-employment/start-sever-employment.component';
import { SeverEmploymentReview } from './sever-employment-review/sever-employment-review.component';
import { SeverEmploymentService } from './sever-employment.service';
import { SeverEmploymentReceiptComponent } from './sever-employment-receipt/sever-employment-receipt.component';
import { SeverEmploymentPayComponent } from './sever-employment-pay/sever-employment-pay.component';
import { PaymentModule } from '../../shared/payment/payment.module';


const routes: Routes = [
  { path: 'severEmployer', component: StartSeverEmploymentComponent, canActivate: [AuthGuard]},
  { path: 'severEmploymentNotification', component: SeverEmploymentNotificationComponent, canActivate: [AuthGuard]},
  { path: 'severEmploymentReview', component: SeverEmploymentReview, canActivate: [AuthGuard]},
  { path: 'severEmploymentReceipt', component: SeverEmploymentReceiptComponent, canActivate: [AuthGuard]},
  { path: 'severEmploymentPay', component: SeverEmploymentPayComponent, canActivate: [AuthGuard]},

 //SeverEmploymentPayComponent { path: '', component: CompleteSeverEmploymentComponent, canActivate: [AuthGuard]},
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes), 
    FormsModule, 
    PTLSharedModule, 
    NgxPrintModule, 
    PaymentModule
  ],
  
  declarations: [
    StartSeverEmploymentComponent,  
    SeverEmploymentNotificationComponent, 
    SeverEmploymentReview, 
    SeverEmploymentReceiptComponent, 
    SeverEmploymentPayComponent
  ],
  providers :[SeverEmploymentService]
})
export class SeverEmploymentModule { }



// WEBPACK FOOTER //
// ./src/app/broker/sever-employment/sever-employement.module.ts